<template>
	<div class="popular-artists-container">
		<div class="menuBox">
			<div class="naviBox">
				<div class="naviItem" :class="curNaviIndex == index ? 'active' : 'normal'"
					v-for="(item,index) in naviData" :key="index" @click="curNaviIndex = index">
					{{item.title}}
				</div>
			</div>
			<div class="timeBox">
				<div class="timeItem" :class="curTimeIndex == 1 ? 'active' : 'normal'" @click="timeChange(1)">
					月榜
				</div>
				<div class="line"></div>
				<div class="timeItem" :class="curTimeIndex == 2 ? 'active' : 'normal'" @click="timeChange(2)">
					周榜
				</div>
			</div>
		</div>
		<div class="rankListBox">
			<div class="rankTitle" :style="{'background' : naviData[curNaviIndex].background}">
				{{naviData[curNaviIndex].title}}
			</div>
			<div class="rankList">
				<div class="rankItem" v-for="(item,index) in artists[naviData[curNaviIndex].value]" :key="index">
					<div class="rankNum">
						{{index > 2 ? index + 1 : ''}}
						<img class="rankImg" src="../assets/Home/first.png" v-if="index == 0" />
						<img class="rankImg" src="../assets/Home/second.png" v-if="index == 1" />
						<img class="rankImg" src="../assets/Home/third.png" v-if="index == 2" />
					</div>
					<div class="avatarName">
						<img class="avatar" :src="item.avatar" v-if="item.avatar" />
						<img class="avatar" src="../assets/defaultAvatar.png" v-else />
						<div class="nickname ellipsis-1">{{item.user_nickname}}</div>
					</div>
					<div class="articleFansFollowHomePage">
						<div class="article">
							作品数量：
							<span>{{item.work_count}}</span>
						</div>
						<div class="fans">
							粉丝数量：
							<span>{{item.fs_count}}</span>
						</div>
						<div class="followHomePage">
							<div class="follow" :class="item.gz_status == 0 ? 'followed' : 'unFollow'"
								@click="huaGuanZhu(item)">{{item.gz_status == 0 ? '关注' : '已关注'}}</div>
							<div class="homePage" @click="naviToPainter(item)">画师主页</div>
						</div>
					</div>
					<div class="mainWorkBox">
						<div class="mainWork">代表作品：</div>
						<div class="work"
							@click="$router.push({path: '/work-details',query: {id:item.work.id,userId: item.work.user_id}})">
							<img class="workImg" :src="item.work && item.work.img ? item.work.img : ''" />
							<div class="workInfo">
								<div class="workTitle ellipsis-1">
									{{item.work && item.work.title ? item.work.title : ''}}
								</div>
								<div class="workDesc ellipsis-2">
									{{item.work && item.work.content ? item.work.content : ''}}
								</div>
								<div class="tips">
									<div class="tip" v-if="item.work.cid">
										{{item.work && item.work.cid ? item.work.cid : ''}}
									</div>
									<template v-for="(item,index) in item.work.yongtu">
										<div class="tip" :key="index" v-if="index < 3">
											{{item}}
										</div>
									</template>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'PopularArtists',
		data() {
			return {
				curNaviIndex: 0,
				naviData: [{
					title: '新锐榜',
					value: 'xinrui',
					background: '#CDBB98'
				}, {
					title: '实力榜',
					value: 'shili',
					background: '#E6D9C5'
				}, {
					title: '勤奋榜',
					value: 'qinfen',
					background: '#E2DFC6'
				}],
				artists: {},
				curTimeIndex: 1,
			}
		},
		mounted() {
			if (this.$route.query.type) {
				this.curNaviIndex = this.$route.query.type
			}
			this.getArtists()
		},
		methods: {
			//画师榜
			getArtists() {
				this.$api.post('/Other/hua_ph', {
					time_where: this.curTimeIndex,
					user_id: localStorage.getItem('userId') ? localStorage.getItem('userId') : 0
				}).then(res => {
					if (res.code == 1) {
						this.artists = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			//关注画师
			huaGuanZhu(item) {
				if (localStorage.getItem('token')) {
					this.$api.post('/Hua/guanzhu', {
						mb_id: item.id
					}).then(res => {
						if (res.code == 1) {
							this.$message.success(res.msg)
							this.getArtists()
						}
					}).catch(err => {
						console.log(err);
					})
				} else {
					this.$router.replace({
						path: '/login',
					})
				}
			},
			naviToPainter(item) {
				this.$router.push({
					path: '/painter-homepage',
					query: {
						id: item.id
					}
				})
			},
			timeChange(index) {
				this.curTimeIndex = index
				this.getArtists()
			}
		}
	}
</script>

<style lang="scss" scoped>
	.popular-artists-container {
		display: flex;
		flex-direction: column;
		align-items: center;
		background: #FDFDF4;
		min-height: 100vh;
	}

	.menuBox {
		margin: .24rem 0;
		width: 12rem;
		display: flex;
		align-items: center;
		justify-content: space-between;

		.naviBox {
			display: flex;
			align-items: center;

			.naviItem {
				margin-right: .24rem;
				display: flex;
				align-items: center;
				justify-content: center;
				width: .96rem;
				height: .4rem;
				background: #E29358;
				font-size: .16rem;
				text-align: center;
				line-height: .4rem;
				cursor: pointer;
			}

			.active {
				font-weight: 500;
				color: #252525;
				background: #E29358;
			}

			.normal {
				font-weight: 400;
				color: #000000;
				background: rgba(226, 147, 88, .3);
			}
		}

		.timeBox {
			display: flex;
			align-items: center;
			margin-right: .16rem;

			.line {
				height: .14rem;
				border-right: .02rem solid #CFCFCF;
			}

			.timeItem {
				margin: 0 .16rem;
				font-weight: 400;
				font-size: .16rem;
				text-align: center;
				cursor: pointer;
			}

			.active {
				color: #E29358;
			}

			.normal {
				color: #000000;
			}
		}
	}

	.rankListBox {
		width: 12rem;
		margin-bottom: .8rem;
		background: #FFFFFF;
		box-shadow: 0px 2px 24px 0px rgba(183, 183, 183, 0.12);
		border-radius: .12rem;
		overflow: hidden;

		.rankTitle {
			height: .64rem;
			padding-left: .32rem;
			font-weight: 700;
			font-size: .24rem;
			color: #272726;
			line-height: .64rem;
		}

		.rankList {
			display: flex;
			flex-direction: column;
			padding: 0 .32rem;

			.rankItem:last-child {
				border-bottom: none;
			}

			.rankItem {
				height: 1.74rem;
				display: flex;
				align-items: center;
				border-bottom: .01rem solid #EAEAEA;

				.rankNum {
					width: .68rem;
					display: flex;
					align-items: center;
					justify-content: center;
					font-weight: 400;
					font-size: .24rem;
					color: #6B6C30;

					.rankImg {
						width: .36rem;
						height: .42rem;
					}
				}

				.avatarName {
					display: flex;
					flex-direction: column;
					align-items: center;
					width: 1.78rem;
					margin-left: .12rem;

					.avatar {
						width: .9rem;
						height: .9rem;
						border-radius: 50%;
						object-fit: cover;
					}

					.nickname {
						width: 1.78rem;
						margin-top: .12rem;
						font-weight: 400;
						font-size: .16rem;
						color: #252525;
						text-align: center;
					}
				}

				.articleFansFollowHomePage {
					display: flex;
					flex-direction: column;
					margin-left: .12rem;

					.article,
					.fans {
						margin-bottom: .18rem;
						font-weight: 500;
						font-size: .16rem;
						color: #333333;

						span {
							font-family: 400;
							color: #252525;
						}
					}

					.followHomePage {
						display: flex;
						align-items: center;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						line-height: .36rem;
						text-align: center;

						.follow {
							margin-right: .16rem;
							width: .6rem;
							height: .36rem;
							border-radius: 4px;
							line-height: .36rem;
							cursor: pointer;
						}

						.followed {
							background: #E29358;
						}

						.unFollow {
							background: #CCCCCC;
						}

						.homePage {
							width: .88rem;
							height: .36rem;
							background: #EFD8B8;
							border-radius: 4px;
							cursor: pointer;
						}
					}
				}

				.mainWorkBox {
					display: flex;
					margin-left: .64rem;

					.mainWork {
						width: .8rem;
						font-weight: 500;
						font-size: .16rem;
						color: #333333;
					}

					.work {
						margin-left: .16rem;
						display: flex;
						cursor: pointer;

						.workImg {
							width: .92rem;
							height: 1.22rem;
							object-fit: cover;
						}

						.workInfo {
							width: 4.2rem;
							margin-left: .24rem;
							display: flex;
							flex-direction: column;

							.workTitle {
								font-weight: 700;
								font-size: .24rem;
								color: #000000;
							}

							.workDesc {
								margin-top: .1rem;
								font-weight: 400;
								font-size: .14rem;
								line-height: .2rem;
								color: #333333;
							}

							.tips {
								margin-top: .16rem;
								display: flex;
								align-items: center;

								.tip {
									height: .26rem;
									margin-right: .12rem;
									padding: 0 .08rem;
									font-weight: 400;
									font-size: .12rem;
									color: #7C3E0B;
									line-height: .24rem;
									border-radius: .13rem;
									border: .01rem solid #A88653;
								}
							}
						}
					}
				}
			}
		}
	}
</style>